/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".route-wrapper[_ngcontent-%COMP%]{margin-bottom:64px}"];
export { styles as styles };
